export default __webpack_public_path__ + "static/acontece-2d24feeb5060414336bf5c90f8d68b6a.png";